module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
    var _ = require('lodash');
    var lstcaptions = _.find(Property, function(obj) { return obj._id === 'captions' });

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height)+2 ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; color:#000000;\">\r\n\r\n\r\n\r\n\r\n    <div class=\"pf-control-core pf-selectable\"    style=\"width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n            background:")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;            \r\n            font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n            font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n            color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n            overflow:hidden;\" >\r\n         <div style=\"position:relative; top:0; text-align:center; z-index:20; width:100%; height:")
    ; __append(escapeFn( 10 + u.extractNum(fontSize)))
    ; __append("px;\r\n                    border:1px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append("; background-color:")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                    border-top-left-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px; border-top-right-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\">\r\n         	UP\r\n         </div>\r\n         <div id=\"controlRankingListDiv\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) - ((10 + u.extractNum(fontSize)) * 2) ))
    ; __append("px;overflow:auto;border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\">\r\n         	<ul style=\"list-style:none; padding:5px; margin:0; white-space: nowrap;\">\r\n                ")
    ;  if (this.model.attributes.flag ){
    ; __append("\r\n                    ")
    ;  if (lstcaptions && lstcaptions.Item ){
    ; __append("\r\n                        ")
    ;  lstcaptions.Item.forEach(function(value){
    ; __append("\r\n                            <li style=\"padding-bottom:3px;\"> ")
    ; __append(value._value )
    ; __append("</li>\r\n                        ")
    ;  }); 
    ; __append("\r\n                    ")
    ;  } 
    ; __append("\r\n                ")
    ; }else{
    ; __append("\r\n                    ")
    ;  gridData.forEach(function(value){
    ; __append("\r\n                        <li>")
    ; __append(escapeFn(value.item))
    ; __append("</li>\r\n                    ")
    ;  }); 
    ; __append("\r\n                ")
    ; }
    ; __append("\r\n         	</ul>\r\n         </div>\r\n         <div style=\"position:relative; left:0px; bottom: 1px; text-align:center; z-index:10; width:100%; height:")
    ; __append(escapeFn( 10 + u.extractNum(fontSize)))
    ; __append("px;\r\n                     border:1px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append("; background-color:")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                     border-bottom-left-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px; border-bottom-right-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\">\r\n         	DOWN\r\n         </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height:8px;\"></div>\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; height:8px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n</div>")
  }
  return __output;

}